<template>
  <div class="tx-dealersearch module-dealersearch-heading">
    <div class="heading__heading">
      <h1 class="heading beta">{{ $t('dealersearch.' + mandant + '.heading') }}</h1>
    </div>
    <div class="heading__text">
      <span>{{ $t('dealersearch.' + mandant + '.text') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DealersearchHeading',
  data () {
    return {
      mandant: ''
    }
  },
  mounted () {
    const self = this
    self.mandant = window.app.dealersearch_list.client
  }
}
</script>
